import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { ModalCloseIcon } from '../Icons';
import { Divider } from '@mui/material';

interface Props {
	open: boolean;
	setOpen: (value: boolean) => void;
	children: any;
	title?: string;
	style?: React.CSSProperties | {};
	header?: boolean;
	orderFlow?: boolean;
	maxHeight?: number;
}

const modalStyling = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	outline: 'none !important',
	maxWidth: '600px',
	maxHeight: '480px',
	backgroundColor: 'background.paper',
	borderRadius: '4px',
	boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
};

export default function CustomModal({
	open,
	setOpen,
	orderFlow,
	style,
	title,
	children,
	header = true,
	maxHeight,
}: Props) {
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const maxHeightStyle = maxHeight ? { maxHeight: `${maxHeight}px` } : {};
	const mobileStyle = {
		...modalStyling,
		...style,
	};

	return (
		<Modal
			open={open}
			onClose={() => {
				if (!orderFlow) handleClose();
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box
				sx={{
					...modalStyling,
					...maxHeightStyle,
					...style,
					position: 'absolute',
					top: '50%',
					left: '50%',
					outline: 'none',
					transform: 'translate(-50%, -50%)',
					'@media (max-width: 600px)': mobileStyle,
				}}
			>
				{header ? (
					<>
						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							px={2}
							width="100%"
							height="56px"
						>
							<Typography variant="body1">{title}</Typography>
							<Box sx={{ cursor: 'pointer' }} onClick={handleClose}>
								<ModalCloseIcon />
							</Box>
						</Box>
						<Divider style={{ width: '100%' }} />
					</>
				) : null}
				{children}
			</Box>
		</Modal>
	);
}
